import { render, staticRenderFns } from "./FilterSummaryOptionElk.vue?vue&type=template&id=448db1a8&"
import script from "./FilterSummaryOptionElk.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionElk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports